import axios from 'axios';
import { constants } from '../Helpers/constantsFile';
import { COPY } from './login.copy';

/**
 * The one call that checks a username and password.
 *
 * Both doors on the login screen go through here — the sign-in card, the
 * waiter unlock pop-up, and the check that adding a waiter performs. What
 * differs is what the caller does with the answer: two of them sign the user
 * in, and the third throws the token away.
 */

export const WAITER = 'waiter';

/**
 * @param {{username: string, password: string}} credentials
 * @returns {Promise<{user: Object, token: string}>}
 * @throws the axios error, for `authErrorMessage` to read
 */
export async function authenticate({ username, password }) {
  const response = await axios.post(`${constants.baseUrl}/users/authenticate`, {
    username,
    password,
    version: 'notify_version',
  });

  return {
    user: response.data?.data?.user,
    token: `Bearer ${response.data?.token}`,
  };
}

/** The role as the SERVER reported it — never as anything typed on screen. */
export function isWaiter(user) {
  return user?.role === WAITER;
}

/** A business id, whether the server populated the business or sent its id. */
export function businessIdOf(user) {
  const business = user?.business;
  if (!business) return '';
  return String(typeof business === 'object' ? business._id || '' : business);
}

/**
 * Offline is worth saying plainly: a wrong password and a dead router look
 * identical to a POST, and only one of them is the cashier's fault.
 */
export function authErrorMessage(error) {
  if (!navigator.onLine) return COPY.offline;
  return error?.response?.data?.message || COPY.genericAuthError;
}
